import Notices from './notices';
export default Notices;
